// extracted by mini-css-extract-plugin
export var actions = "_u9-4";
export var item = "_u9-1";
export var price = "_u9-3";
export var quantity = "_u9-2";
export var table = "_u9-0";